// TODO export this constant from web-ui
export enum TagName {
  Input = 'INPUT',
  Textarea = 'TEXTAREA',
  Button = 'BUTTON',
  Anchor = 'A',
}
